import styled from 'styled-components';
import { AllieQueryInputProps } from './QueryInput.types';
import { AllieTextArea } from '../TextArea';
import { AllieItem } from '../../Item/Item';
import { MouseEventHandler } from 'react';

export const QueryInputStyled = styled(AllieTextArea)<AllieQueryInputProps>`
  margin-top: 0;
  &&& {
    --padding-start: var(--allie-spacing-xl);
    --padding-end: var(--allie-spacing-5xl);
    --padding-top: var(--allie-spacing-xl);
    --padding-bottom: var(--allie-spacing-xl);
    --color: var(--allie-color-neutral-70);

    ${({ borderColor, background }: AllieQueryInputProps) => `
      ${borderColor && `--border-color: var(--allie-color-${borderColor})`};
      ${background && `--background: var(--allie-color-${background})`};
    `}
    --border-width: 1.5px;
    --border-style: solid;
    border: var(--border-width) var(--border-style) var(--border-color);
    &:hover {
      ${({ borderColorHover }: AllieQueryInputProps) =>
        borderColorHover && `--border-color: var(--allie-color-${borderColorHover})`};
    }
    &:focus {
      ${({ borderColorHover }: AllieQueryInputProps) =>
        borderColorHover && `--border-color: var(--allie-color-${borderColorHover})`};
      outline: none;
    }
  }
`;

export const AllieItemStyled = styled.div.attrs<{ onclick?: () => void; disabled?: boolean }>(
  (props) => ({
    onClick: props.disabled ? undefined : (props.onclick as MouseEventHandler<HTMLDivElement>),
  })
)<{ onclick?: () => void; suffixAlign?: string; disabled?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transform: ${({ suffixAlign }) =>
    suffixAlign === 'top' ? 'translateY(-4px)' : 'translateY(8px)'};
  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  .icon-wrapper {
    font-size: 36px;
    color: var(--allie-color-primary-90);
  }
`;
